export default __webpack_public_path__ + "static/media/sizza.0d8107ed.png";